import React from 'react';
import { useShowContext } from 'framework/show';
import { FormShowTemplate } from 'framework/form';
import Risks from '../../risks/Risks';
import { EditableListFormShowTemplate } from 'framework/list';
import { getRisksInitialData } from '../../risks/utils';

const ProjectDashboardRisksWrapper = () => {
  const { data } = useShowContext();

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      submitFormFunc={() => Promise.resolve()}
      initialData={getRisksInitialData(data)}
    >
      <EditableListFormShowTemplate listSource="risks" localStorageKey={`project:${data?.id}:risks`}>
        <Risks
          titleVariant="h4"
          accordionSx={{
            '.MuiAccordionSummary-root': { minHeight: '40px !important', pl: 2, pr: 0, py: 1 },
            '.MuiSvgIcon-root': { fontSize: '20px' },
            '.MuiAccordionDetails-root .MuiGrid2-root': { px: 0.3 },
          }}
          gridSx={{ pl: 1, pr: '0px !important' }}
        />
      </EditableListFormShowTemplate>
    </FormShowTemplate>
  );
};
export default ProjectDashboardRisksWrapper;
